module.exports = __webpack_public_path__ + "static/media/CSID.7e2e8899.png";